// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"304":"d9a03ac0","2589":"f23d057c","5251":"e14ba622","9447":"8bb6e83b"}[chunkId] + ".chunk.css";
};